/**
 * queue-sort-values — the raw value each sortable column orders by.
 *
 * Kept apart from the cells on purpose: a cell renders for a human ("3d 2h",
 * "30/07/2026", a badge) and every one of those strings sorts wrong. These are
 * the machine-comparable equivalents.
 *
 * Imports nothing from queue-columns, so the column config can pull these in
 * without a cycle.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { QueueElement } from '@trafficpulse/shared';

/**
 * Final tested-for in SECONDS: the recorded duration, else time elapsed since
 * the test started. Sorting the rendered label would put "3d 2h" below
 * "6h 2m" — it compares "3" against "6".
 */
export function testedForSeconds(el: QueueElement): number | null {
  if (el.testDurationSeconds != null) return el.testDurationSeconds;
  if (!el.testStartedAt) return null;
  const started = new Date(el.testStartedAt).getTime();
  if (Number.isNaN(started)) return null;
  return (Date.now() - started) / 1000;
}

/** An ISO timestamp as epoch ms — never compare the dd/mm/yyyy render. */
export function epochOf(iso: string | null): number | null {
  if (!iso) return null;
  const t = Date.parse(iso);
  return Number.isNaN(t) ? null : t;
}

/** The tri-state the Tracker badge shows, flattened to something orderable. */
export function trackerSortValue(el: QueueElement): string {
  if (el.addedToTracker) return '1-live';
  return el.trackerRemovedAt ? '2-deleted' : '3-absent';
}

/** Default group first, then rule name, ungrouped last — as the sections read. */
export function ruleSortValue(el: QueueElement): string {
  if (!el.rule) return '~';
  return el.rule.isDefault ? '' : el.rule.name;
}
